export const TRANSACTION_CONFIG_PREFERENCE_TYPE = 'preferenceType=Config,entity=Transaction';

export const BUSINESS_TRANSACTION_TYPES = {
    ipDealRequest: 'IPDealRequest',
    peopleDealRequest: 'PeopleDealRequest'
} as const;

export type BusinessTransactionType = (typeof BUSINESS_TRANSACTION_TYPES)[keyof typeof BUSINESS_TRANSACTION_TYPES];

export const PREFERENCE_ENTITY_CONTEXTS_CONSTANT = {
    productionWorkspace: 'Workspace',
    submissionPipeline: 'SubmissionPipeline',
    shortlist: 'Shortlist',
    booking: 'Booking',
    production: 'Production',
    organization: 'Organization',
    organizationAccount: 'OrganizationAccount',
    people: 'People',
    peopleAccount: 'PeopleAccount',
    lead: 'Lead',
    order: 'Order',
    reservation: 'Reservation',
    catalog: 'Catalog',
    marketplace: 'Marketplace',
    resourceTemplate: 'ResourceTemplate',
    report: 'Report',
    buyMemo: 'BuyMemo',
    peopleDealBuyMemo: 'PeopleDealBuyMemo',
    titleAbstract: 'TitleAbstract'
};
